import React from "react";
import { Link, useLocation } from "react-router-dom";

const ITEMS: Array<{ to: string; label: string; match: (p: string) => boolean }> = [
  { to: "/admin/voices", label: "Voices", match: (p) => p.startsWith("/admin/voices") },
  { to: "/admin/donors", label: "Donors", match: (p) => p.startsWith("/admin/donors") },
  { to: "/admin/payments", label: "Payments", match: (p) => p.startsWith("/admin/payments") },
  { to: "/admin/invoices", label: "Invoices", match: (p) => p.startsWith("/admin/invoices") },
  { to: "/admin/statements", label: "Statements", match: (p) => p.startsWith("/admin/statements") },
  { to: "/admin/connect", label: "Connect", match: (p) => p.startsWith("/admin/connect") },
];

/**
 * Shared top toolbar across every /admin/* page.
 * Same monospace styling as VoicesAdmin's existing toolbar.
 */
export function AdminTopNav() {
  const { pathname } = useLocation();
  return (
    <nav
      aria-label="Admin"
      className="flex flex-wrap items-baseline gap-x-5 gap-y-2 mb-10 border-b border-hairline pb-5"
    >
      {ITEMS.map((it) => (
        <Link
          key={it.to}
          to={it.to}
          className={
            it.match(pathname)
              ? "font-mono text-xs uppercase tracking-widest text-claude font-bold"
              : "font-mono text-xs uppercase tracking-widest text-ink-3 hover:text-ink"
          }
        >
          {it.label}
        </Link>
      ))}
    </nav>
  );
}
